import { combineReducers } from 'redux';
import productReducer from '../features/products/products';
import appReducer from '../features/app/app';

export default combineReducers({
  products: productReducer,
  app: appReducer
});
